import clsx from "clsx";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import DataTableWrapper from "../../components/DataTableWrapper";
import DetailBlock from "../../components/DetailBlock";
import Loader from "../../components/Loader";
import PaddingContainer from "../../components/PaddingContainer";
import StatusIndicator from "../../components/StatusIndicator";
import TableValue from "../../components/TableValue";
import { DownloadIcon, DownloadPDFIcon } from "../../constant";
import { bookingViewDetails, paymentMethods } from "../../data";
import {
  amPmTimeFormat,
  formatNumberWithCommas,
  formattedDate,
  renderCommand,
} from "../../helpers";
import { convertUtcToLocalTime } from "../../helpers/exportHelpers";
import { exportDetailsToPDF } from "../../pdfs/bookings/bookingDetailPdf";
import { setLastVisitedPage } from "../../store/bookingFilterSlice";
import { setPageLink, setPageTitle } from "../../store/pageSlice";
import useApi from "../../useApi";
import classes from "./BookingDetailPage.module.css";
import RescheduleBookingModal from "../../modals/Bookings/ReschduleBooking";
import { CalendarIcon } from "../../constant";
const getStatusLabel = (statusId) => {
  switch (statusId) {
    case 1:
      return "Confirmed";
    case 2:
      return "Cancelled";
    case 3:
      return "Pending";
    default:
      return "--";
  }
};
const isBookingPassed = (bookingDate, bookingEndTime) => {
  if (!bookingDate || !bookingEndTime) return false;

  // Create a datetime by combining the date and end time
  const bookingEndDateTime = moment(
    `${bookingDate} ${bookingEndTime}`,
    "YYYY-MM-DD HH:mm:ss"
  );
  const now = moment();

  // Return true if booking end time is before current time
  return bookingEndDateTime.isBefore(now);
};

const columns = (items, setSelectedItem, navigate) => [
  {
    field: "payNo",
    header: "Payment ID",
    body: (rowData) => {
      return (
        <TableValue top={rowData?.payNo?.split("-")?.slice(1).join("-")} />
      );
    },
  },
  {
    field: "paymentDate",
    header: "Date",
    body: (rowData) => {
      return (
        <TableValue
          top={
            rowData?.paymentDate &&
            formattedDate(convertUtcToLocalTime(rowData?.paymentDate || ""))
          }
          down={moment(
            convertUtcToLocalTime(rowData?.paymentDate || "")
          ).format("HH:mm A")}
        />
      );
    },
  },
  {
    field: "amount",
    header: "Amount",
    body: (rowData) => (
      <TableValue top={`Rs. ${formatNumberWithCommas(rowData?.amount)}`} />
    ),
  },
  {
    field: "paymentMode",
    header: "Payment Mode",
    body: (rowData) => (
      <TableValue
        top={
          paymentMethods?.find((item) => item?.value === rowData?.paymentModeId)
            ?.label || "--"
        }
      />
    ),
  },

  {
    field: "paymentStatusId",
    header: "Payment Status",
    body: (rowData) => (
      <StatusIndicator
        bookingStatus={rowData?.paymentStatusId}
        action={false}
      />
    ),
  },
  {
    field: "attachment",
    header: "Download",
    body: (rowData) => {
      // if (!rowData?.attachment)

      return (
        <div
          disabled={!rowData?.attachment}
          className={clsx(classes.downloadIcon, {
            [classes.disabled]: !rowData?.attachment,
          })}
          onClick={() => {
            if (!rowData?.attachment) return;
            // Create anchor element to trigger download
            const link = document.createElement("a");
            link.href = rowData.attachment;
            link.download = `payment-${rowData?.payNo
              ?.split("-")
              ?.slice(1)
              .join("-")}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
        >
          <DownloadIcon />
        </div>
      );
    },
  },
];
const slotsColumn = (items, setSelectedItem, navigate) => [
  {
    field: "bookingStartTime",
    header: "Slot Time",
    body: (rowData) => {
      return (
        <TableValue
          top={`${amPmTimeFormat(rowData?.bookingStartTime)} - ${amPmTimeFormat(
            rowData?.bookingEndTime
          )}`}
        />
      );
    },
  },
  {
    field: "amount",
    header: "Amount",
    body: (rowData) => {
      return (
        <TableValue top={`Rs. ${formatNumberWithCommas(rowData?.charges)}`} />
      );
    },
  },
];
const formattedDateHandler = ({
  bookingDate,
  bookingStartTime,
  bookingEndTime,
}) => {

  // Convert to time range (1-hour slot)
  const startTime = moment(bookingStartTime, "HH:mm:ss").format("hh:mm A"); // "04:00 PM"
  const endTime = moment(bookingEndTime, "HH:mm:ss").format("hh:mm A");
  return (
    <TableValue
      top={formattedDate(bookingDate)}
      down={`${startTime} - ${endTime}`}
    />
  );
};
// const exportDetailsToPDF = (bookingDetails) => {
//   console.log("Booking Details:", bookingDetails);

//   // Get primary player details
//   const primaryPlayer = bookingDetails?.bookingPlayers?.find(
//     (player) => player?.isPrimary
//   );

//   const doc = new jsPDF("p", "mm", "a4");

//   // Add logo at the top
//   const imgWidth = 40; // Width of the logo in mm
//   const imgHeight = 15; // Height of the logo in mm
//   const pageWidth = doc.internal.pageSize.width;
//   const logoXPos = (pageWidth - imgWidth) / 2; // Center horizontally

//   // Add logo image
//   doc.addImage(logo, "PNG", logoXPos, 10, imgWidth, imgHeight);

//   // Title and Reference ID
//   doc.setFontSize(16);
//   doc.text("Booking Details", 14, 35);
//   doc.text(
//     `Reference ID: ${bookingDetails?.bookingNo
//       ?.split("-")
//       ?.slice(1)
//       .join("-")}`,
//     14,
//     45
//   );

//   // Customer Details section
//   doc.setFontSize(12);
//   doc.text("Customer Details:", 14, 55);

//   // Calculate positions and spacing
//   const contentWidth = pageWidth - 28; // Total width minus margins
//   let xPos = 14;
//   let yPos = 65;
//   const labelValueGap = 3;
//   const pairGap = 10;

//   // Function to add a label-value pair inline with wrap capability
//   const addInlinePair = (label, value) => {
//     // Check if this pair would go beyond page width
//     const labelWidth = doc.getTextWidth(label);
//     const valueWidth = doc.getTextWidth(value || "--");
//     const totalWidth = labelWidth + labelValueGap + valueWidth + pairGap;

//     // If adding this pair would exceed page width, move to next line
//     if (xPos + totalWidth > contentWidth) {
//       xPos = 14; // Reset to left margin
//       yPos += 10; // Move to next line
//     }

//     // Add the label-value pair
//     doc.setFont(undefined, "bold");
//     doc.text(label, xPos, yPos);
//     xPos += labelWidth + labelValueGap;

//     doc.setFont(undefined, "normal");
//     doc.text(value || "--", xPos, yPos);
//     xPos += valueWidth + pairGap;
//   };

//   // Add all customer details in a single flowing line (wrapping only when necessary)
//   const detailsMap = [
//     { label: "Name:", value: primaryPlayer?.playerFullName },
//     { label: "Phone:", value: primaryPlayer?.playerCellNumber },
//     { label: "Email:", value: primaryPlayer?.playerEmail },
//     { label: "Location:", value: bookingDetails?.locationName },
//     { label: "Court:", value: bookingDetails?.courtName },
//     { label: "Address:", value: bookingDetails?.locationAddress },
//     { label: "Date:", value: formattedDate(bookingDetails?.bookingDate) },
//     {
//       label: "Time:",
//       value: `${moment(bookingDetails?.bookingStartTime, "HH:mm:ss").format(
//         "hh:mm A"
//       )} - ${moment(bookingDetails?.bookingEndTime, "HH:mm:ss").format(
//         "hh:mm A"
//       )}`,
//     },
//     {
//       label: "Amount:",
//       value: `Rs. ${formatNumberWithCommas(bookingDetails?.bookingNetAmount)}`,
//     },
//     {
//       label: "Status:",
//       value: getStatusLabel(bookingDetails?.bookingStatusId),
//     },
//   ];

//   // Add all pairs, automatically wrapping to new lines as needed
//   detailsMap.forEach((detail) => {
//     addInlinePair(detail.label, detail.value);
//   });

//   // Draw a line under customer details with some space
//   const finalCustomerDetailsY = yPos + 5;
//   doc.setLineWidth(0.1);
//   doc.line(
//     14,
//     finalCustomerDetailsY,
//     doc.internal.pageSize.width - 14,
//     finalCustomerDetailsY
//   );

//   // Continue with payment details table, starting at the new position
//   doc.setFontSize(14);
//   doc.text("Payment Details", 14, finalCustomerDetailsY + 10);

//   // Update the start Y position for the payment details table
//   const paymentTableStartY = finalCustomerDetailsY + 15;

//   const paymentHeaders = [
//     ["Payment ID", "Date", "Amount", "Payment Mode", "Payment Status"],
//   ];

//   const paymentRows = bookingDetails?.bookingPayments?.map((payment) => [
//     payment?.payNo?.split("-")?.slice(1).join("-"),
//     `${formattedDate(payment?.paymentDate)} ${moment(
//       payment?.paymentDate
//     ).format("hh:mm A")}`,
//     `Rs. ${formatNumberWithCommas(payment?.amount)}`,
//     paymentMethods?.find((item) => item?.value === payment?.paymentModeId)
//       ?.label || "--",
//     payment?.paymentStatusId === 1 ? "Success" : "Failed",
//   ]);

//   // Add payment details table
//   autoTable(doc, {
//     head: paymentHeaders,
//     body: paymentRows || [],
//     startY: paymentTableStartY,
//     theme: "grid",
//     styles: {
//       fontSize: 8,
//       cellPadding: 3,
//     },
//     headStyles: {
//       fillColor: [58, 134, 221],
//       textColor: [255, 255, 255],
//       fontSize: 9,
//       fontStyle: "bold",
//     },
//   });

//   // Add logo to new pages if needed
//   const addNewPage = () => {
//     doc.addPage();
//     doc.addImage(logo, "PNG", logoXPos, 10, imgWidth, imgHeight);
//     return 40; // Return starting Y position for content
//   };

//   // Slot Details section with new page check
//   if (doc.lastAutoTable.finalY > doc.internal.pageSize.height - 60) {
//     doc.text("Slot Details", 14, addNewPage());
//   } else {
//     doc.text("Slot Details", 14, doc.lastAutoTable.finalY + 15);
//   }

//   const slotHeaders = [["Slot Time", "Amount"]];

//   const slotRows = bookingDetails?.bookingBreakdowns?.map((slot) => [
//     `${moment(slot?.bookingStartTime, "HH:mm:ss").format("hh:mm A")} - ${moment(
//       slot?.bookingEndTime,
//       "HH:mm:ss"
//     ).format("hh:mm A")}`,
//     `Rs. ${formatNumberWithCommas(slot?.charges)}`,
//   ]);

//   autoTable(doc, {
//     head: slotHeaders,
//     body: slotRows || [],
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "grid",
//     styles: {
//       fontSize: 8,
//       cellPadding: 3,
//     },
//     headStyles: {
//       fillColor: [58, 134, 221],
//       textColor: [255, 255, 255],
//       fontSize: 9,
//       fontStyle: "bold",
//     },
//   });

//   doc.save(
//     `booking_details_${bookingDetails?.bookingNo
//       ?.split("-")
//       ?.slice(1)
//       .join("-")}.pdf`
//   );
// };

const exportDetailsToCSV = (bookingDetails) => {
  // Get primary player details
  const primaryPlayer = bookingDetails?.bookingPlayers?.find(
    (player) => player?.isPrimary
  );

  // Create headers and data for main details
  const mainDetails = [
    ["Booking Details"],
    ["Reference ID", bookingDetails?.bookingNo?.split("-")?.slice(1).join("-")],
    ["Customer Name", primaryPlayer?.playerFullName || "--"],
    ["Phone Number", primaryPlayer?.playerCellNumber || "--"],
    ["Email", primaryPlayer?.playerEmail || "--"],
    ["Location", bookingDetails?.locationName || "--"],
    ["Court Name", bookingDetails?.courtName || "--"],
    ["Location Address", bookingDetails?.locationAddress || "--"],
    ["Booking Date", formattedDate(bookingDetails?.bookingDate) || "--"],
    [
      "Booking Time",
      `${moment(bookingDetails?.bookingStartTime, "HH:mm:ss").format(
        "hh:mm A"
      )} - ${moment(bookingDetails?.bookingEndTime, "HH:mm:ss").format(
        "hh:mm A"
      )}`,
    ],
    [
      "Total Amount",
      `Rs. ${formatNumberWithCommas(bookingDetails?.bookingNetAmount)}`,
    ],
    [
      "Collected Amount",
      `Rs. ${formatNumberWithCommas(bookingDetails?.bookingCollectedAmount)}`,
    ],
    ["Status", getStatusLabel(bookingDetails?.bookingStatusId)],
    [""], // Empty row for spacing
  ];

  // Add payment details
  const paymentDetails = [
    ["Payment Details"],
    ["Payment ID", "Date", "Amount", "Payment Mode", "Payment Status"],
    ...(bookingDetails?.bookingPayments?.map((payment) => [
      payment?.payNo?.split("-")?.slice(1).join("-"),
      `${formattedDate(payment?.paymentDate)} ${moment(
        payment?.paymentDate
      ).format("hh:mm A")}`,
      `Rs. ${formatNumberWithCommas(payment?.amount)}`,
      paymentMethods?.find((item) => item?.value === payment?.paymentModeId)
        ?.label || "--",
      payment?.paymentStatusId === 1 ? "Success" : "Failed",
    ]) || []),
    [""], // Empty row for spacing
  ];

  // Add slot details
  const slotDetails = [
    ["Slot Details"],
    ["Slot Time", "Amount"],
    ...(bookingDetails?.bookingBreakdowns?.map((slot) => [
      `${moment(slot?.bookingStartTime, "HH:mm:ss").format(
        "hh:mm A"
      )} - ${moment(slot?.bookingEndTime, "HH:mm:ss").format("hh:mm A")}`,
      `Rs. ${formatNumberWithCommas(slot?.charges)}`,
    ]) || []),
  ];

  // Combine all data
  const csvData = [...mainDetails, ...paymentDetails, ...slotDetails];

  // Convert to CSV format
  const csvContent = csvData.map((row) => row.join(",")).join("\n");

  // Create and download file
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `booking_details_${bookingDetails?.bookingNo
    ?.split("-")
    ?.slice(1)
    .join("-")}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const BookingDetail = () => {
  const { id } = useParams();
  const { getBookingsAdmin } = useApi();
  const location = useLocation();
  const [bookingDetails, setBookingDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showRescheduleBookingModal, setShowRescheduleBookingModal] =
    useState(false);
  // Mark that we're on the booking detail page
  useEffect(() => {
    dispatch(setLastVisitedPage("bookingDetail"));
    dispatch(setPageTitle("Booking"));
    dispatch(setPageLink(-1));
  }, [dispatch]);

  // Get booking data from navigation state
  const bookingData = location.state?.bookingData;
  console.log("bookingDetails locations ==>", location.state);
  console.log("bookingDetails", bookingDetails);
  const getBookingsRelatedAdminById = async (params) => {
    setLoading(true);
    try {
      const result = await getBookingsAdmin(params);
      if (result?.data?.headers?.error === 200) {
        setBookingDetails(result?.data?.body?.items[0]);
      } else {
        toast.error(result?.data?.headers?.message);
        // Navigate back if API fails
        navigate("/dashboard");
      }
    } catch (error) {
      toast.error("Failed to fetch booking details");
      navigate("/dashboard");
    }

    setLoading(false);
  };
  // useEffect(() => {
  //   dispatch(setPageTitle("Booking"));
  //   dispatch(setPageLink("/dashboard"));
  // }, []);
  useEffect(() => {
    if (!id) {
      // navigate("/dashboard");
      // return;
    }

    // If we have booking data from navigation, use it
    if (bookingData && id) {
      setBookingDetails(bookingData);
    } else {
      // Otherwise fetch from API
      getBookingsRelatedAdminById({
        id: id,
        search: "",
        pageNumber: 1,
        pageSize: 10,
        bookingDateStart: moment().subtract(5, "years").format("YYYY-MM-DD"),
        bookingDateEnd: moment().add(5, "years").format("YYYY-MM-DD"),
        locationId: null,
        courtId: null,
        bookingStatusId: null,
        isPaid: null,
        isDesc: false,
        bookingAdminSortId: 1,
      });
    }
  }, [id, bookingData]);

  // if (!bookingDetails) {
  //   return null;
  // }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <PaddingContainer>
          <div className={classes.header}>
            <h2 className={classes.mainTitle}>View Details</h2>

            <div className={classes.headerActions}>
             
              <Button
                className={classes.downloadButton}
                label={"Reschedule"}
                leftIcon={
                  <span className={classes.downloadIcon}>
                    <CalendarIcon className={classes.icon} />
                  </span>
                }
                onClick={() => setShowRescheduleBookingModal(true)}
              />
               <Button
                className={classes.downloadButton}
                label={"Download PDF"}
                leftIcon={
                  <span className={classes.downloadIcon}>
                    <DownloadPDFIcon className={classes.icon} />
                  </span>
                }
                onClick={() => exportDetailsToPDF(bookingDetails)}
              />
            </div>
          </div>
          <section className={classes.wrapper}>
            <h2 className={classes.title}>
              Reference ID:{" "}
              {bookingDetails?.bookingNo.split("-")?.slice(1)?.join("-")}
            </h2>
            <Row className={classes.bookingDetails}>
              {bookingViewDetails.map((item, index) => {
                console.log("item ==>", item);
                return (
                  <Col md={item?.key === "locationAddress" ? 8 : 4} key={index}>
                    <DetailBlock
                      label={item.label}
                      value={renderCommand(
                        item?.command,
                        bookingDetails?.[item?.key],
                        bookingDetails
                      )}
                    />
                  </Col>
                );
              })}
            </Row>

            <Row>
              <Col md={7}>
                <h3 className={classes.title}>Payment Details</h3>
                {/* Add more booking details here */}
                <div className={classes.tableWrapper}>
                  <DataTableWrapper
                    data={bookingDetails?.bookingPayments || []}
                    columns={columns([], null, navigate)}
                    loading={loading}
                    showPaginator={false}
                  />
                </div>
              </Col>
              <Col md={5}>
                <h3 className={classes.title}>Slot Details</h3>
                <div className={classes.tableWrapper}>
                  <DataTableWrapper
                    data={bookingDetails?.bookingBreakdowns || []}
                    columns={slotsColumn([], null, navigate)}
                    loading={loading}
                    showPaginator={false}
                  />
                </div>
              </Col>
            </Row>
          </section>
        </PaddingContainer>
      )}

      {showRescheduleBookingModal && (
        <RescheduleBookingModal
          data={bookingDetails}
          show={showRescheduleBookingModal}
          setShow={() => setShowRescheduleBookingModal(false)}
        />
      )}
    </>
  );
};

export default BookingDetail;
